export default __webpack_public_path__ + "static/media/Northword Blue Cirle.139c7483.png";